

































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import lodash from 'lodash';
import { Plan } from '@/models/plan';
import { DeliveryStateDisplay, DeliveryStateType } from '@common/enums/order';
import BasicModal from '@/components/common/BasicModal.vue';
import EditDelivery from '@components/order/EditDelivery.vue';
import ModalRefund from '@components/order/ModalRefund.vue';
import ModalEditAmount from '@components/order/ModalEditAmount.vue';
import { Tracking } from '@/models/tracking';
import ApiHelper from '@/api/ApiHelper';
import Toast from '@common/helpers/toast';
import { Roles } from '@/common/app.config';

@Component({
  components: {
    BasicModal,
    EditDelivery,
    ModalRefund,
    ModalEditAmount,
  },
  data() {
    return {
      lodash,
      moment,
      DeliveryStateDisplay,
    };
  },
  filters: {
    formatNum: (value) => {
      let formatedString = '0';
      if (value) {
        formatedString = value
          .toString()
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      }

      return `${formatedString}円`;
    },
  },
})
export default class OrderTrackingTable extends Vue {
  @Prop(Array) readonly tracking: Tracking[];
  @Prop(Object) readonly plan: Plan;
  @Prop(Array) readonly selectedTrackingIds: number[];
  private deliveryItem = {};
  private internalSelectedTrackingIds: number[] = [];
  private DeliveryStateType = DeliveryStateType;

  @Watch('selectedTrackingIds', { immediate: true })
  onSelectedTrackingIdsChange(val: number[]) {
    this.internalSelectedTrackingIds = [...(val || [])];
  }

  get canManageSkip() {
    const user = this.$store.state.auth.currentUser;
    return user && (user.isSuperAdminRole || user.isCSRole);
  }

  get showSkipColumn() {
    if (!this.canManageSkip) {
      return false;
    }
    if (!this.tracking || this.tracking.length === 0) {
      return false;
    }
    // Hide if no tracking has a delivery_date (order not yet prescribed)
    const hasAnyDeliveryDate = this.tracking.some((t) => !!t.delivery_date);
    if (!hasAnyDeliveryDate) {
      return false;
    }
    // Hide if the first tracking hasn't been paid (order not yet paid)
    const firstTracking = this.tracking.find((t) => t.delivery_sequence === 1);
    if (firstTracking && !firstTracking.paid_at) {
      return false;
    }
    return true;
  }

  get selectableTrackings() {
    return this.tracking.filter(
      (item) =>
        (this.canSkip(item) || this.canUnskip(item)) &&
        item.delivery_sequence !== 1,
    );
  }

  get isAllSelected() {
    return (
      this.selectableTrackings.length > 0 &&
      this.internalSelectedTrackingIds.length ===
        this.selectableTrackings.length
    );
  }

  private toggleSelectAll() {
    if (this.isAllSelected) {
      this.internalSelectedTrackingIds = [];
    } else {
      this.internalSelectedTrackingIds = this.selectableTrackings
        .map((t) => t.id)
        .filter((id): id is number => id !== undefined);
    }
    this.$emit('update:selectedTrackingIds', this.internalSelectedTrackingIds);
  }

  private isSelected(item: Tracking) {
    return (
      item.id !== undefined &&
      this.internalSelectedTrackingIds.includes(item.id)
    );
  }

  private toggleSelection(item: Tracking) {
    if (
      (!this.canSkip(item) && !this.canUnskip(item)) ||
      item.delivery_sequence === 1
    ) {
      return;
    }

    if (item.id === undefined) {
      return;
    }

    const newSelection = [...this.internalSelectedTrackingIds];
    const index = newSelection.indexOf(item.id);
    if (index > -1) {
      newSelection.splice(index, 1);
    } else {
      newSelection.push(item.id);
    }

    this.internalSelectedTrackingIds = newSelection;
    this.$emit('update:selectedTrackingIds', newSelection);
  }

  private canUnskip(item) {
    return item.state === DeliveryStateType.Skipped && this.isFuture(item);
  }

  private canSkip(item) {
    return (
      !!item.delivery_date &&
      lodash.includes(
        [
          DeliveryStateType.ReadyForDelivery,
          DeliveryStateType.PreparingForDelivery,
          DeliveryStateType.NotPaid,
        ],
        item.state,
      )
    );
  }

  private isFuture(item) {
    return moment(item.delivery_date).isAfter(moment(), 'day');
  }

  private showIconRefund(value: any) {
    const refundAmount = lodash.sumBy(
      value.orders_tracking_history_refunded,
      (item: any) => {
        return parseInt(item.amount);
      },
    );
    return parseInt(value.amount) - refundAmount;
  }

  private showEditDelivery(item) {
    this.deliveryItem = item;
    this.$modal.show('modalEditDelivery');
  }

  private showRefund(item) {
    this.deliveryItem = item;
    this.$modal.show('modalRefundAmount');
  }

  private showEditAmount(item) {
    this.deliveryItem = item;
    this.$modal.show('modalEditAmount');
  }

  private isShowDeliveryIcon(state) {
    return lodash.includes(
      [
        DeliveryStateType.NotPaid,
        DeliveryStateType.Paid,
        DeliveryStateType.ReadyForDelivery,
        DeliveryStateType.ErrorPaid,
        DeliveryStateType.ScheduledDelivery,
      ],
      state,
    );
  }

  private isShowEditAmountIcon(state) {
    return lodash.includes(
      [DeliveryStateType.NotPaid, DeliveryStateType.ErrorPaid],
      state,
    );
  }
}
